import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ChatComponent } from './chat.component';

/**
 * 聊天面板的 `@defer` 宿主，唯一職責是把 {@link ChatComponent} 切出 initial bundle。
 *
 * ## 為什麼需要這一層
 *
 * `<app-chat>` 原本直接寫在 `top-bar.component.html` 的 cdkConnectedOverlay
 * `<ng-template>` 內。overlay 未開啟時確實不會實例化，但**樣板仍是靜態編譯的**，
 * 整棵 `pages/chat`（首屏 39 KB，含 message-item 與 moment 的 duration）
 * 因此留在 initial bundle。
 *
 * `@defer` 能切開它，但**只有 standalone 宿主才會真的分包**：
 * NgModule 宣告的元件（`TopBarComponent` 即是）其樣板相依來自 `NgModule.imports`
 * （一律 eager），編譯器無從產生動態載入 —— `@defer` 會照常運作，但不會有 chunk，
 * 而且**不報錯**，很容易誤以為做完了。與 `wallet-connect-cta` 是同一個理由。
 *
 * ## 觸發條件
 *
 * 用 `on immediate` 而非 `when`：本元件本身就位在 overlay 的 `<ng-template>` 內，
 * 只有 overlay 開啟時才會被建立，因此「被建立」等同於「使用者要看聊天室了」，
 * 不需要再多一個條件。
 */
@Component({
  selector: 'app-chat-panel',
  standalone: true,
  imports: [ChatComponent],
  template: `
    @defer (on immediate) {
      <app-chat></app-chat>
    } @placeholder {
    } @error {}
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatPanelComponent {}
